// File: cgp-app-card.module.ts
// Author: Joseph M Diaz
// Date: 6/6/2018
// Desc: Module for the cgp app card.
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";

import { CgpAppCardComponent } from './cgp-app-card.component';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule
    ],
    exports: [
        CgpAppCardComponent
    ],
    declarations: [
        CgpAppCardComponent
    ]
})
export class CgpAppCardModule { }